// Trial workspaces are still installing; everyone else has the snippet live already.
export function isInstallSnippetOpen({
	toggled,
	isTrial,
	hasWidgetSettings,
}: {
	toggled: boolean | null
	isTrial: boolean
	hasWidgetSettings: boolean
}): boolean {
	if (!hasWidgetSettings) return true
	return toggled ?? isTrial
}
